module.exports = __webpack_public_path__ + "img/stock3.8d6fd51f.png";